import { selector } from "recoil";
import axios from "axios";
import { executeLinksAPI } from "../utils/LinksAPI";
import { COMMUNICATE_ERROR_MESSAGE_LATEST_VERSION } from "../constants/ErrorMessage";

export const authorizationQuery = selector({
  key: 'authorizationQuery',
  get: async () => {

    const auth = await Promise.all([
      authorization(),
      arincLatestVersion()
    ]).then(values => {
      return {...values[0], ...values[1]};
    });

    return auth;
  }
});

export const authorization = () => {
  const config = {
    method: 'get',
  };
  return executeLinksAPI('fosterlinks/user/authorization', config)
    .then(data => {
      return data;
    }).catch((error) => {
      console.error('authorization failed.');
      throw error;
    });
};

const arincLatestVersion = () => {
  const apiUrl = process.env.REACT_APP_ARINC_API_URL;
  const apiKey = process.env.REACT_APP_ARINC_API_KEY;
  const config = {
      method: 'get',
      url: `${apiUrl}/latest_version`,
      headers: { 
          'x-api-key': apiKey
      },
      errorHandle: {
        message: COMMUNICATE_ERROR_MESSAGE_LATEST_VERSION
      }
  };

  return axios(config)
    .then(res => {
      return res.data;
    }).catch((error) => {
      console.error('get latest_version failed.');
      throw error;
    });
};
